import { createSlice } from "@reduxjs/toolkit";

export type CertificateExpiryActiveTab = "expiring_soon" | "expired";

interface CertificateExpirySliceInterface {
    activeTab: CertificateExpiryActiveTab;
    currentPage: number;
    itemsPerPage: number;
    itemsPerPageSelect: { value: number; activeValue: boolean }[];
    sort: {
        sortName: string;
        isSorted: boolean;
    };
}

const initialState: CertificateExpirySliceInterface = {
    activeTab: "expiring_soon",
    currentPage: 1,
    itemsPerPage: 12,
    itemsPerPageSelect: [
        { value: 12, activeValue: true },
        { value: 25, activeValue: false },
        { value: 50, activeValue: false },
    ],
    sort: {
        sortName: "",
        isSorted: false,
    },
};

const CertificateExpirySlice = createSlice({
    name: "certificateExpirySlice",
    initialState,
    reducers: {
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;

            state.itemsPerPageSelect = state.itemsPerPageSelect.map((item) => {
                return {
                    ...item,
                    activeValue: item.value === action.payload,
                };
            });
        },
        setSort: (state, action) => {
            state.sort = action.payload;
        },
    },
});

export const certificateExpiryReducer = CertificateExpirySlice.reducer;

export const { setActiveTab, setItemsPerPage, setCurrentPage, setSort } =
    CertificateExpirySlice.actions;
